import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AddContact } from "./AddContact";

export const EditContact = () => {
  const location = useLocation();
  const [userId, setUserId] = useState();
  useEffect(() => {
    let userId = location.pathname.split("/")[2];
    if (userId) {
      setUserId(userId);
    }
  }, []);

  return (
    <>
      <AddContact contactId={userId} />
    </>
  );
};
